export default {
  selectedPlanState: state => state.selectedPlan,
  getMyPlan: state => state.myPlan,
  invoicePlanState: state => state.invoicePlan,
  selectedModuleForPlanState: state => state.selectedModuleForPlan
}
